<template>
    <div class="c-avatar">
        <div class="c-avatar__circle">
            <span class="c-avatar__initials">{{user.initials}}</span>
        </div>
        <div class="c-avatar__name">
            {{user.name}}
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState({
            user: (state) => state.user.data
        })
    }
}
</script>
